import { entryCards } from "@/mocks/homeData";

const toneMap: Record<string, { icon: string; badge: string; ring: string }> = {
  primary: {
    icon: "bg-primary-500 text-background-50",
    badge: "bg-primary-100 text-primary-700",
    ring: "hover:border-primary-300",
  },
  accent: {
    icon: "bg-accent-500 text-background-50",
    badge: "bg-accent-100 text-accent-900",
    ring: "hover:border-accent-300",
  },
  secondary: {
    icon: "bg-secondary-500 text-background-50",
    badge: "bg-secondary-100 text-secondary-900",
    ring: "hover:border-secondary-300",
  },
};

export default function EntryOverview() {
  return (
    <section id="entries" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-apps-2-line" />
            入口总览
          </span>
          <h2 className="mt-3 font-heading text-foreground-950 text-2xl md:text-4xl">
            进入平台的三条路径，先选适合你的那条
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            不同使用习惯适合不同入口。下面把网页端、客户端与地址获取三种方式并列说明，方便你对照自己的情况快速决定。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {entryCards.map((card) => {
            const tone = toneMap[card.accent] ?? toneMap.primary;
            return (
              <article
                key={card.title}
                className={`rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6 transition-colors ${tone.ring}`}
              >
                <div className="flex items-center justify-between">
                  <span className={`w-12 h-12 flex items-center justify-center rounded-lg text-2xl ${tone.icon}`}>
                    <i className={card.icon} />
                  </span>
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${tone.badge}`}>
                    {card.tag}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-foreground-950 text-xl">{card.title}</h3>
                <p className="mt-3 text-foreground-600 text-sm leading-relaxed">{card.desc}</p>
                <ul className="mt-4 space-y-2">
                  {card.points.map((point) => (
                    <li key={point} className="flex items-start gap-2 text-foreground-700 text-sm">
                      <i className="ri-checkbox-circle-line text-primary-500 mt-0.5" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}